<template>
    <div :class="showStripeForm ? 'lock-screen' : ''">
        <NuxtLoadingIndicator :height="3" color="#5959FF" />
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>

        <!-- * layout dialog that is used all over app -->
        <LazyAppLayoutDialog v-if="showGlobalDialog" />

        <!-- * snackbar that is used all over app -->
        <!-- ! need to check -->
        <LazyAppSnackbar
            v-if="showSnackbar && !useRoute().fullPath.includes('/payment')"
            :description="snackContent.description"
            :placement="snackContent.placement"
            :state="snackContent.state"
        />
        <SubAccountModal @close-modal="subAccountData.showState = false" />
        <LazyAppNoActivePlan v-if="showNoActivePlan" />
        <!--  cookie control dialog -->
        <AppCookieControl />
        <AppAuthForm v-if="showAuthModal" />
        <PricingCheckoutForm v-if="showStripeForm" />
    </div>
</template>

<script setup lang="ts">
import SubAccountModal from "~/modules/sub-account/components/modals/SubAccountModal.vue";
import { usePermission } from "@vueuse/core";
import { useSubAccountStore } from "~/modules/sub-account/store";
import { useUserStore } from "./store/global/user.store";
import { useLayoutDialog } from "~/store/components/layout-dialog.store";
import { v4 as uuidv4 } from "uuid";
import { useAuthStore } from "./features/authentication/store";

const { showAuthModal } = storeToRefs(useAuthStore());
const AppAuthForm = defineAsyncComponent({
    loader: () => import("./features/authentication/components/AppAuthForm.vue"),
});

const { showStripeForm } = storeToRefs(usePricingStore());
const PricingCheckoutForm = defineAsyncComponent({
    loader: () => import("./modules/pricing/components/checkout-form/PricingCheckoutForm.vue"),
});

const { $clientPosthog } = useNuxtApp();
const { showNoActivePlan } = storeToRefs(useUserStore());
const { showGlobalDialog } = useLayoutDialog();
const { showSnackbar, snackContent } = useSnackbar();
const auth = useAuth();
const { setUtm } = useUtm();
const { $firebase } = useNuxtApp();
const { initializeGoogleOneTap } = useOnetapHandler();

const notificationsAccess = usePermission("notifications");
// * get user credits and info
const { getUserData } = useUserStore();

const { execute } = await getUserData({ immediate: false });

const { subAccountData } = storeToRefs(useSubAccountStore());

const viaQuery = useRoute().query.via;
if (viaQuery && viaQuery === "miamirealtors") {
    useCookie("is_miami_realtor", {
        maxAge: 63072000,
    }).value = "true";
}
const id = useId();
onMounted(async () => {
    if (!auth.value) initializeGoogleOneTap();

    if (auth.value) {
        $clientPosthog?.capture("aihd_user_init_app", {
            $set: { name: useUserStore().userData.email, email: useUserStore().userData.email },
            $set_once: { initial_url: useRoute().path },
        });

        // @ts-ignore
        window.dataLayer?.push({
            event: "Auth",
            Email: useUserStore().userData.email,
            UserID: id,
        });
    }

    setUtm();

    $firebase();

    // * block referrals from google ads (code pasted from task link)
    let referral_url = new URL(window.location.href);
    if (referral_url.searchParams.has("gclid") && referral_url.searchParams.has("via")) {
        setTimeout(function () {
            useCookie("rewardful.referral", { path: "/", domain: window.location.hostname }).value = null;
        }, 2000);
    }
    if (!useCookie("device_id").value) {
        useCookie("device_id").value = uuidv4();
    } else return;
});

watch(notificationsAccess, async () => {
    if (notificationsAccess.value === "granted") {
        navigator.serviceWorker.register("/firebase-messaging-sw.js").then(() => {
            setTimeout(() => {
                $firebase();
            }, 500);
        });
    }
});

watchImmediate(auth, async () => {
    if (auth.value) await execute();
});
</script>

<style>
@import url("~/assets/css/cookie-control.css");

html:has(.lock-screen) {
    overflow: hidden !important;
}

.cookie-hidden {
    display: none;
}
::-webkit-scrollbar {
    width: 4px;
}
::-webkit-scrollbar-track {
    @apply bg-black bg-opacity-10;
}
::-webkit-scrollbar-thumb {
    @apply bg-gray-700 rounded-full;
}
::-webkit-scrollbar-thumb:hover {
    @apply bg-gray-500;
}
::-webkit-scrollbar-thumb:active {
    @apply bg-gray-200;
}
</style>
